import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#claudiademedio')

Vue.use(VueAnalytics, {
  id: 'UA-27107122-9',
  router
})